export const Standard = 'Standard';
export const Custom = 'Custom';
